import { createContext, useCallback, useRef } from 'react'

export type ReloadCallback = () => void | Promise<void>

export const ScreenWideReloadContext = createContext<{
  addReloadListener: (listener: ReloadCallback) => () => void
  reload: () => Promise<void>
}>({
  addReloadListener: () => () => undefined,
  reload: () => Promise.resolve(),
})

export function ScreenWideReloadProvider({ children }: { children: React.ReactNode }) {
  const reloadListeners = useRef<ReloadCallback[]>([])

  const addReloadListener = useCallback((listener: ReloadCallback) => {
    reloadListeners.current.push(listener)

    return () => {
      reloadListeners.current = reloadListeners.current.filter((l) => l !== listener)
    }
  }, [])

  const reload = useCallback(async () => {
    await Promise.allSettled(reloadListeners.current.map((listener) => listener()))
  }, [])

  return (
    <ScreenWideReloadContext.Provider value={{ addReloadListener, reload }}>
      {children}
    </ScreenWideReloadContext.Provider>
  )
}
